import { createPaymentClient } from 'grabbitbot-legacy-ui'
import { apiClient } from './client'
import { createPortalClient } from './portalClient'
import { createTradingClient } from './tradingClient'
import { createStatisticsClient } from './statisticsClient'
import { createBotControlClient } from './botControlClient'
import { createAdminClient } from './adminClient'

export { apiClient, tokenStorage } from './client'

// Shared-library payment contract (current payment generation:
// plans/products/usage-fees/billing/credit/transactions/invoices) plus this
// app's own GrabbitBot-specific reads (old-payment probe, exchange picker,
// service accounts) — see src/api/portalClient.ts.
export const paymentClient = createPaymentClient(apiClient)
export const portalClient = createPortalClient(apiClient)
// B2: v3 config (default/coin/tags/quote assets/strategies) + exchange key.
export const tradingClient = createTradingClient(apiClient)
// B3: statistics (profit/treasury/commission/usage-fee/global-profit/
// transactions) + read-only bot views (positions/wallet) + the two legacy
// (non-v3) reads (closed price, balance-vs-mop).
export const statisticsClient = createStatisticsClient(apiClient)
// B4: bot control (start bot, close/delete positions, manual buy) —
// BUSINESS-CRITICAL, every route places/closes/deletes a real order.
export const botControlClient = createBotControlClient(apiClient)
// B6: admin back-office (users, payment, credit, bot control, logs,
// statistics) — BUSINESS-CRITICAL, see src/api/adminClient.ts.
export const adminClient = createAdminClient(apiClient)
